import { useState, useEffect } from 'react';

interface CookiePreferences {
  essential: boolean;
  analytics: boolean;
  lastUpdated: string;
}

const defaultPreferences: CookiePreferences = {
  essential: true, // Always true as these are required
  analytics: false,
  lastUpdated: new Date().toISOString()
};

export function useCookieConsent() {
  const [preferences, setPreferences] = useState<CookiePreferences>(() => {
    const saved = localStorage.getItem('cookiePreferences');
    return saved ? JSON.parse(saved) : defaultPreferences;
  });

  const updatePreferences = (newPreferences: Partial<CookiePreferences>) => {
    const updated = {
      ...preferences,
      ...newPreferences,
      lastUpdated: new Date().toISOString()
    };
    setPreferences(updated);
    localStorage.setItem('cookiePreferences', JSON.stringify(updated));
    
    // Apply preferences
    if (!updated.analytics) {
      // Disable analytics cookies
      document.cookie = '_ga=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = '_gid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }
  };

  return { preferences, updatePreferences };
}